import QueryString from 'query-string';
import * as Sentry from '@sentry/browser';

export default class FetchJSON {

  static fetch(url, method = 'GET', data = {}) {
    return new Promise(function(resolve, reject) {
      let postData = null;

      if (method === 'GET') {
        if (url.indexOf('?') === -1) {
          url += '?' + QueryString.stringify(data);
        }
      } else {
        postData = JSON.stringify(data);
      }

      let xhr = new XMLHttpRequest();
      xhr.open(method, url, true);
      xhr.setRequestHeader("Content-type", "application/json;charset=UTF-8");
      xhr.send(postData);

      xhr.onload = function() {
        resolve(JSON.parse(xhr.response));
        destroy();
      }

      xhr.onerror = function(error) {
        Sentry.captureException(error);
        reject(error);
        destroy();
      }

      function destroy() {
        xhr.onload = null;
        xhr.onerror = null;
        xhr = null;
      }
    });
  }
}
